import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || "http://localhost:8000"}/api`,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("clinic_erp_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    // Public pages that must not redirect on 401
    const publicPaths = ["/"];
    const isPublicPage = publicPaths.includes(window.location.pathname);
    if (status === 401 && !isPublicPage && window.location.pathname !== "/login") {
      localStorage.removeItem("clinic_erp_token");
      localStorage.removeItem("clinic_erp_user");
      localStorage.removeItem("clinic_erp_clinic");
      window.location.replace("/login");
    }
    return Promise.reject(error);
  },
);

export default API;
